import { useMemo, useState } from 'react'
import Label from '../../../ui/Label'
import DropdownBtn from '../../../ui/DropdownBtn'
import ErrorMessage from '../../../ui/ErrorMessage'
import Loading from '../../../ui/Loading'
import { selectCurrentProduct, selectNewProductCategory, updateNewProduct } from '../../../../features/product/productSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useInitializeProductForm } from '../../../../hooks/product/useInitializeProductForm'
import { selectCurrentModalType } from '../../../../features/modal/modalSlice'
import { getRtkErrorMessage } from '../../../../utils/getRtkErrorMessage'
import { CategoryData } from '../../../../features/setup/setupResponse'
// import { Category } from '../../../../types/category'

export default function ProdModCategory() {

    const dispatch = useDispatch()
    const [isOpenDropdownCategory, setIsOpenDropdownCategory] = useState<boolean>(false)
    const category = useSelector(selectNewProductCategory);
    const typeModal = useSelector(selectCurrentModalType);
    const selectedProduct = useSelector(selectCurrentProduct);
    const { allCategories, isLoadingAllCategories, isErrorCategories, errorAllCategories,
    } = useInitializeProductForm(
        typeModal,
        selectedProduct,
    );
    const errorMessageAllCategories = getRtkErrorMessage(errorAllCategories);

    const activeCategories = useMemo(() => {
        return allCategories.filter(
            (opt: CategoryData) => opt.isActive
        );
    }, [allCategories]);

    return (
        <div className=''>
            <Label label={'Category *'}/>
            <div className='relative inline-block h-auto w-full'>
                <div className='w-full h-auto'>
                    <DropdownBtn
                        label={category?.label || 'Select Category'}
                        isOpen={isOpenDropdownCategory}
                        setIsOpenStatus={setIsOpenDropdownCategory}
                        isCustomClass={true}
                        customClass={'flex w-full justify-between items-center rounded transition px-2  text-black py-1.5 space-x-2 text-xs  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                    />
                    {isOpenDropdownCategory && (
                        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                            {isLoadingAllCategories ? (
                                <li className='px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-xs w-full'>
                                    <Loading setH={'h-[20px]'}/>
                                </li>
                            ) : isErrorCategories ? (
                                <li className='px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-xs w-full'>
                                    <ErrorMessage message={errorMessageAllCategories} setH={'h-[20px]'}/>
                                </li> 
                            ) : (
                                activeCategories.map((opt: CategoryData) => (
                                    <li
                                        key={opt.categoryID}
                                        onClick={() => {
                                            // setSelectedCategory(opt.categoryName)
                                            setIsOpenDropdownCategory(false)
                                            dispatch(updateNewProduct({ category: {
                                                id: opt.categoryID,
                                                label: opt.categoryName
                                            } }))
                                        }}
                                        className='px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-xs w-full'
                                    >
                                        {opt.categoryName}
                                    </li>
                                ))
                            )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    )
}
